module.exports = __webpack_public_path__ + "img/40db11c8ecf6a87ed4c2e1c22c80c44f.svg";